import {gsap} from "gsap/all";
import $ from "jquery";


export class ScenarioAdmin {

  constructor($scenarioEl) {
    this.$scenarioEl = $scenarioEl;
    this.opened = false;
    this.currentAction = null;

    this.reset();
  }

  setScenarioActions(actionSelector) {
    if (this.currentAction === actionSelector) return;
    this.currentAction = actionSelector;

    // Skip actons for Free Roaming scenario as it's just a simple button
    if (this.$scenarioEl.data("scenario-machine-name") === "scenario5") return;

    const tl = gsap.timeline({})

    // Hide current action
    const $activeAction = this.$scenarioEl.find(".actions .active");
    if ($activeAction.length > 0) {
      tl.to($activeAction, {scale: 0.95, autoAlpha: 0, duration: 0.2});
      $activeAction.removeClass("active");
    }

    // Show selected tool
    if (this.$scenarioEl.length > 0) {
      tl.fromTo(this.$scenarioEl.find(`.actions ${actionSelector}`), {scale: 1.05, autoAlpha: 0}, {scale: 1, autoAlpha: 1, duration: 0.2}, "-=0.1");
      this.$scenarioEl.find(`.actions ${actionSelector}`).addClass('active');
    }

    // Toggle text
    if (!this.opened && actionSelector !== ".read-more") {
      this.opened = true;
      this.$scenarioEl.addClass('opened');
      this.slideDown();
    } else if (this.opened && actionSelector === ".read-more") {
      this.opened = false;
      this.$scenarioEl.removeClass('opened');
      this.slideUp();
    }
  }

  slideUp() {
    gsap.to($(".scenario-description", this.$scenarioEl), {height: 0})
  }

  slideDown() {
    gsap.to($(".scenario-description", this.$scenarioEl), {height: 'auto'})
  }

  lock() {
    this.$scenarioEl.find(".actions").addClass("locked");
  }

  unlock() {
    this.$scenarioEl.find(".actions").removeClass("locked");
  }

  reset() {
    $(`.scenario.opened`).removeClass('opened started');
    gsap.set($('.scenario-description', this.$scenarioEl), {height: 0})
    this.setScenarioActions(".read-more")
    this.unlock();
  }

}
